import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_done",
  "use": "icon-icon_done-usage",
  "viewBox": "0 0 1026 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1026 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_done\"><path d=\"M512 0a512 512 0 1 0 512 512 512 512 0 0 0-512-512z m0 960a448 448 0 1 1 448-448 448 448 0 0 1-448 448z\" fill=\"#666666\" p-id=\"4699\" /><path d=\"M718.08 329.6l-293.76 294.4-120.96-120.96a32 32 0 0 0-47.36 45.44l143.36 143.36a32 32 0 0 0 45.44 0l316.8-316.8a32 32 0 0 0-45.44-45.44z\" fill=\"#666666\" p-id=\"4700\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol